import React from 'react';
import PropTypes from 'prop-types';

import CreateSampleEventAction from 'app/shared/components/sample-events/CreateSampleEventAction';

import DebuggerContent from './shared/DebuggerContent';

export default function DebuggerDrawerInputContent({ inputEvent }) {
  return (
    <DebuggerContent
      content={inputEvent}
      lang="json"
      renderActions={decodedJson => <CreateSampleEventAction sampleEventJson={decodedJson} />}
      emptyMessage="No input event for this row."
    />
  );
}

DebuggerDrawerInputContent.propTypes = {
  inputEvent: PropTypes.string,
};
